import { Circ, TweenLite } from "gsap";
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class SubMenu {
    private _view: MovieClip;

    constructor(view: MovieClip) {
        this._view = view;
        this._view.y = this._view.invisibleY;
    }

    public show(): void {
        TweenLite.to(this._view, 0.5, { y: this._view.visibleY, ease: Circ.easeOut });
    }

    public hide(): void {
        TweenLite.to(this._view, 0.8, { y: this._view.invisibleY, ease: Circ.easeOut });
    }

    protected onRollOut(event: MouseEvent): void {
        this.hide();
    }

    public set y(value: number) {
        this._view.y = value;
    }
}
